module.exports = __webpack_public_path__ + "static/retirement3-a746648096cffd9a5e62cbe124f1c2aa.png";